// Color and its per-frame person matte share one MP4, so their timing cannot drift.
// The GPU turns the matte into alpha, keeping live portraits in front of the text.
export function renderPortraitVideo(canvas: HTMLCanvasElement, video: HTMLVideoElement) {
  const gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false });
  if (!gl) throw new Error('Portrait compositing unavailable');
  const shader = (type: number, source: string) => {
    const result = gl.createShader(type)!;
    gl.shaderSource(result, source); gl.compileShader(result);
    if (!gl.getShaderParameter(result, gl.COMPILE_STATUS)) throw new Error('Portrait shader unavailable');
    return result;
  };
  const vertex = shader(gl.VERTEX_SHADER, 'attribute vec2 position; varying vec2 uv; void main(){uv=vec2((position.x+1.0)*0.5,(1.0-position.y)*0.5);gl_Position=vec4(position,0.0,1.0);}');
  const fragment = shader(gl.FRAGMENT_SHADER, 'precision mediump float; varying vec2 uv; uniform sampler2D frames; void main(){vec3 color=texture2D(frames,vec2(uv.x*0.5,uv.y)).rgb;float matte=texture2D(frames,vec2(0.5+uv.x*0.5,uv.y)).r;gl_FragColor=vec4(color,smoothstep(0.08,0.92,matte));}');
  const program = gl.createProgram()!;
  gl.attachShader(program, vertex); gl.attachShader(program, fragment); gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Portrait renderer unavailable');
  gl.useProgram(program);
  const buffer = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,1,1]), gl.STATIC_DRAW);
  const location = gl.getAttribLocation(program, 'position');
  gl.enableVertexAttribArray(location); gl.vertexAttribPointer(location, 2, gl.FLOAT, false, 0, 0);
  const texture = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  canvas.width = video.videoWidth / 2; canvas.height = video.videoHeight;
  gl.viewport(0, 0, canvas.width, canvas.height);
  let stopped = false;
  let frame = 0;
  let lastTime = -1;
  const supportsVideoFrames = typeof video.requestVideoFrameCallback === 'function';
  const draw = () => {
    if (stopped) return;
    if (video.readyState >= 2 && video.currentTime !== lastTime) {
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      lastTime = video.currentTime;
    }
    frame = supportsVideoFrames ? video.requestVideoFrameCallback(draw) : requestAnimationFrame(draw);
  };
  draw();
  return () => {
    stopped = true;
    if (supportsVideoFrames) video.cancelVideoFrameCallback(frame); else cancelAnimationFrame(frame);
    gl.deleteTexture(texture); gl.deleteBuffer(buffer); gl.deleteProgram(program);
    gl.deleteShader(vertex); gl.deleteShader(fragment);
  };
}
